import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  applyToWidget: 0,
  lastRequestedWidget: 0,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    saveApplyToWidget: (state, action: PayloadAction<number>) => {
      state.applyToWidget = action.payload;
    },
    resetApplyToWidget: (state) => {
      state.applyToWidget = 0;
    },
    saveLastRequestedWidget: (state, action: PayloadAction<number>) => {
      state.lastRequestedWidget = action.payload;
    },
    resetLastRequestedWidget: (state) => {
      state.lastRequestedWidget = 0;
    },
  },
});

export const {
  saveApplyToWidget, resetApplyToWidget, saveLastRequestedWidget, resetLastRequestedWidget,
} = dashboardSlice.actions;
export default dashboardSlice.reducer;
